<template>
  <div>
    <slot name="label"></slot>
    <input
      id="user_password"
      v-model="password"
      :placeholder="passwordPlaceholder"
      name="user[password]"
      type="password"
      class="form-control"
      autocomplete="new-password"
    />
    <div class="PasswordStrengthMeter">
      <div
        :data-score="passwordStrength"
        :style="passwordStrengthMeterStyle"
        class="PasswordStrengthMeter_Fill"
      ></div>
    </div>
    <div v-if="known">
      <slot name="known"></slot>
    </div>
    <div v-if="password && !isSecurePassword">
      <slot name="insecure"></slot>
    </div>
    <slot name="hints"></slot>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import debounce from "lodash/debounce";

export default {
  name: "PasswordStrengthMeter",
  props: {
    passwordPlaceholder: {
      type: String,
      required: true,
    },
    minimumPasswordScore: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      password: "",
      colorLookup: [
        [this.minimumPasswordScore * 1.6, "green"],
        [this.minimumPasswordScore, "yellowgreen"],
        [this.minimumPasswordScore * 0.8, "orange"],
        [this.minimumPasswordScore * 0.4, "orangered"],
        [0.0, "red"],
      ],
    };
  },
  computed: {
    ...mapGetters({
      passwordStrength: "userForm/passwordStrength",
      known: "userForm/passwordKnown",
    }),
    passwordStrengthMeterStyle() {
      return {
        width: `${this.passwordStrength * 100}%`,
        background: this.findBackgroundColor(),
      };
    },
    isSecurePassword() {
      return new Boolean(this.passwordStrength >= this.minimumPasswordScore).valueOf();
    },
  },
  watch: {
    password: debounce(function(val) {
      this.calculatePasswordStrength(val);
    }, 150),
  },
  methods: {
    ...mapActions({
      calculatePasswordStrength: "userForm/calculatePasswordStrength",
    }),
    findBackgroundColor() {
      const [, backgroundColor] = this.colorLookup.find(([key]) => {
        return this.passwordStrength >= parseFloat(key);
      });
      return backgroundColor;
    },
  },
};
</script>

<style lang="scss">
@import "~styles/global";

.PasswordStrengthMeter {
  position: relative;
  height: 3px;
  background: #ddd;
  margin: 10px auto 20px;
  border-radius: $border-radius;

  &::before,
  &::after {
    content: "";
    height: inherit;
    background: transparent;
    display: block;
    border-color: #fff;
    border-style: solid;
    border-width: 0 5px;
    position: absolute;
    width: 20%;
    z-index: $zi-lowest;
  }

  &::before {
    left: 20%;
  }

  &::after {
    right: 20%;
  }
}

.PasswordStrengthMeter_Fill {
  background: transparent;
  height: inherit;
  position: absolute;
  width: 0;
  border-radius: inherit;
  transition: width 0.5s ease-in-out, background 0.25s;
}
</style>
